import React from 'react';
import ProofOfTransferPresentational from './proof-of-transfer-presentational';

const ProofOfTransferFunctional = () => {
	return <ProofOfTransferPresentational />;
};
export default ProofOfTransferFunctional;
